import { Button, message } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import spuServices from "../../../services/spu";

interface ExportNativePdfProps {
  buttonType: "primary" | "default";
}

const TEMPLATE_NAME = "native-cms-v1";

const parseFileName = (contentDisposition?: string): string | null => {
  if (!contentDisposition) return null;

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const asciiMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
  if (asciiMatch?.[1]) {
    return asciiMatch[1];
  }

  return null;
};

const ExportNativePdf = ({ buttonType = "primary" }: ExportNativePdfProps) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    if (!id || loading) {
      return;
    }

    try {
      setLoading(true);

      const res = await spuServices.postNativePdfExport(String(id), {
        template: TEMPLATE_NAME,
      });

      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const download = document.createElement("a");
      const contentDisposition = res.headers?.["content-disposition"];
      const fileName =
        parseFileName(contentDisposition) || `${t("nativePdf.fallbackFileName")}.pdf`;

      download.href = url;
      download.download = fileName.endsWith(".pdf") ? fileName : `${fileName}.pdf`;
      download.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error(t("nativePdf.message.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button type={buttonType} loading={loading} onClick={handleExport}>
      {t("nativePdf.button")}
    </Button>
  );
};

export default ExportNativePdf;
